import type { BacklogConfig } from "../contracts/BacklogConfig";
import type {
	BacklogRequestBody,
	BacklogRequestOption,
} from "../contracts/api/BacklogRequestOption";
import type {
	BacklogRequestResolver as BacklogRequestResolverContract,
	RequestData,
} from "../contracts/api/BacklogRequestResolver";
import { joinUrlPath } from "../utils/BacklogUtil";

export class BacklogAuthRequestResolver
	implements BacklogRequestResolverContract
{
	constructor(private options: { config: BacklogConfig }) {}

	resolve(options: {
		path: string;
		options: BacklogRequestOption;
		query?: URLSearchParams;
		body?: BacklogRequestBody;
	}): RequestData {
		const args = options;
		const q = args.query || new URLSearchParams();

		const api_key = this.options.config.getApiKey();
		if (api_key) {
			q.append("apiKey", api_key);
		}

		const token = this.options.config.getAccessToken();
		if (token) {
			args.options.headers.append("Authorization", `Bearer ${token}`);
		}

		return {
			url: this.createUrl(args.path, q),
			options: args.options,
		};
	}

	private createUrl(path: string, query?: URLSearchParams): URL {
		const url = new URL(this.options.config.getBaseUrl().toString());

		url.pathname = joinUrlPath(url.pathname, path);

		if (query) {
			query.forEach((value, key) => {
				url.searchParams.append(key, value);
			});
		}

		return url;
	}
}
